module.exports = __webpack_public_path__ + "img/fond_1.d7b30387.png";